import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { AuthCallback, RequireAuth } from "@/lib/auth";
import Giris from "@/pages/Giris";
import SifreSifirla from "@/pages/SifreSifirla";

axios.defaults.withCredentials = true;
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import DashboardPreview from "@/components/DashboardPreview";
import BentoGrid from "@/components/BentoGrid";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import EarlyAccess from "@/components/EarlyAccess";
import Footer from "@/components/Footer";
import Panel from "@/pages/Panel";
import Admin from "@/pages/Admin";

const LandingPage = () => (
  <main className="relative bg-[#07090E] text-slate-50">
    <Header />
    <Hero />
    <Marquee />
    <DashboardPreview />
    <BentoGrid />
    <Pricing />
    <Testimonials />
    <EarlyAccess />
    <Footer />
  </main>
);

const AppRouter = () => {
  // Read the hash from useLocation (reactive) — Emergent auth returns to /panel#session_id=...
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/giris" element={<Giris />} />
      <Route path="/sifre-sifirla" element={<SifreSifirla />} />
      <Route
        path="/panel"
        element={
          <RequireAuth>
            <Panel />
          </RequireAuth>
        }
      />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
